module.exports = __webpack_public_path__ + "img/character-dog-content.301a7e1e.svg";